import styles from "./index.module.scss";

const ItemsPerPageSelector = ({
  label,
  quantityItemsPerPage,
  setQuantityItemsPerPage,
}) => {
  return (
    <div className={styles.ItemsPerPageSelector}>
      <label>{label}</label>
      <select
        name="QuantityItemsPerPage"
        value={quantityItemsPerPage}
        onChange={(e) => setQuantityItemsPerPage(e.target.value)}
      >
        <option value="5">5</option>
        <option value="10">10</option>
        <option value="15">15</option>
        <option value="20">20</option>
        <option value="30">30</option>
        <option value="40">40</option>
        <option value="50">50</option>
      </select>
    </div>
  );
};

export default ItemsPerPageSelector;
